import { Action, createReducer, on } from '@ngrx/store';

import { IUserProfile } from '../interfaces/IUserProfile';
import { setAway, setCancelAway, setCompleteUserState, setUser, unSetUser } from './user.actions';

export interface UserState {
  user: IUserProfile | null;
}

export const userInitialState: UserState = {
  user: null,
};

const _userReducer = createReducer(
  userInitialState,
  on(setUser, (state, { profileInfo }) => ({
    ...state,
    user: { ...profileInfo },
  })),
  on(unSetUser, (state) => ({ ...state, user: null })),
  on(setCompleteUserState, (state, { savedState }) => ({
    ...savedState,
  })),
  on(setAway, (state, { to, userId, message }) => ({
    ...state,
    user: state.user ? { ...state.user, away: { to, userId, message } } : state.user,
  })),
  on(setCancelAway, (state) => ({
    ...state,
    user: state.user ? { ...state.user, away: undefined } : state.user,
  }))
);

export function userReducer(state: UserState, action: Action) {
  return _userReducer(state, action);
}
